import businessSettings from "img/screenshots/authorize_business_settings.png";
import payments from "img/screenshots/authorize_payments.png";
import packaging from "img/screenshots/authorize_add_packaging.png";
import digitalLabel from "img/screenshots/authorize_digital_label.png";
import labelFiles from "img/screenshots/authorize_label_files.png";
import messages from "img/screenshots/authorize_messages.png";
import helpCenter from "img/screenshots/authorize_help_center.png";
import { sgT } from "./translate";

export const AUTHORIZE_START_GUIDE_STEP_IDS = {
  BUSINESS: "business",
  PAYMENTS: "payments",
  PACKAGING: "packaging",
  LABEL: "label",
  DECLARATION: "declaration",
  REPRESENTATIVE: "representative",
  HELP: "help",
};

export const authorizeStartGuideContent = {
  texts: {
    get subtitle() { return sgT("authorize.subtitle"); },
    get allDone() { return sgT("authorize.allDone"); },
    get showPreviousTasks() { return sgT("showPreviousTasks"); },
    tasksLeft: ({ tasksLeft, minutesLeft }) =>
      sgT("tasksLeft", { tasksLeft, minutesLeft }),
    get goal() { return sgT("authorize.goal"); },
    get footerLinks() {
      return [
        { label: sgT("openHelpCenter"), to: "/help" },
        { label: sgT("authorize.goToPackaging"), to: "/packaging" },
      ];
    },
    get nextActions() {
      return [
        {
          title: sgT("authorize.nextActions.labels.title"),
          description: sgT("authorize.nextActions.labels.description"),
          label: sgT("authorize.goToPackaging"),
          to: "/packaging",
          variant: "primary",
        },
        {
          title: sgT("checkDocumentRequests"),
          description: sgT("authorize.nextActions.messages.description"),
          label: sgT("openMessages"),
          to: "/messages?tab=documentRequests",
        },
      ];
    },
  },
  minutesPerTask: 5,
  defaultSteps: [
    {
      id: AUTHORIZE_START_GUIDE_STEP_IDS.BUSINESS,
      step: AUTHORIZE_START_GUIDE_STEP_IDS.BUSINESS,
      get name() { return sgT("businessDetails.name"); },
      category: "required",
      complete: false,
    },
    {
      id: AUTHORIZE_START_GUIDE_STEP_IDS.PAYMENTS,
      step: AUTHORIZE_START_GUIDE_STEP_IDS.PAYMENTS,
      get name() { return sgT("paymentDetails.name"); },
      category: "required",
      complete: false,
    },
    {
      id: AUTHORIZE_START_GUIDE_STEP_IDS.PACKAGING,
      step: AUTHORIZE_START_GUIDE_STEP_IDS.PACKAGING,
      get name() { return sgT("authorize.steps.packaging.name"); },
      category: "required",
      complete: false,
    },
    {
      id: AUTHORIZE_START_GUIDE_STEP_IDS.LABEL,
      step: AUTHORIZE_START_GUIDE_STEP_IDS.LABEL,
      get name() { return sgT("authorize.steps.label.name"); },
      category: "recommended",
      optional: true,
      requires: [AUTHORIZE_START_GUIDE_STEP_IDS.PACKAGING],
      get lockReason() { return sgT("authorize.steps.label.lockReason"); },
      complete: false,
    },
    {
      id: AUTHORIZE_START_GUIDE_STEP_IDS.DECLARATION,
      step: AUTHORIZE_START_GUIDE_STEP_IDS.DECLARATION,
      get name() { return sgT("authorize.steps.declaration.name"); },
      category: "optional",
      optional: true,
      requires: [AUTHORIZE_START_GUIDE_STEP_IDS.LABEL],
      get lockReason() { return sgT("authorize.steps.declaration.lockReason"); },
      complete: false,
    },
    {
      id: AUTHORIZE_START_GUIDE_STEP_IDS.REPRESENTATIVE,
      step: AUTHORIZE_START_GUIDE_STEP_IDS.REPRESENTATIVE,
      get name() { return sgT("authorize.steps.representative.name"); },
      category: "optional",
      optional: true,
      requires: [AUTHORIZE_START_GUIDE_STEP_IDS.LABEL],
      get lockReason() { return sgT("authorize.steps.representative.lockReason"); },
      complete: false,
    },
    {
      id: AUTHORIZE_START_GUIDE_STEP_IDS.HELP,
      step: AUTHORIZE_START_GUIDE_STEP_IDS.HELP,
      get name() { return sgT("help.name"); },
      category: "learn",
      complete: false,
    },
  ],
  steps: {
    [AUTHORIZE_START_GUIDE_STEP_IDS.BUSINESS]: {
      get name() { return sgT("businessDetails.name"); },
      get description() { return sgT("businessDetails.description"); },
      to: "/business-settings?tab=business",
      get actionLabel() { return sgT("fill"); },
      image: businessSettings,
      get actions() {
        return [
          {
            label: sgT("fill"),
            to: "/business-settings?tab=business",
            variant: "primary",
          },
        ];
      },
    },
    [AUTHORIZE_START_GUIDE_STEP_IDS.PAYMENTS]: {
      get name() { return sgT("paymentDetails.name"); },
      get description() { return sgT("authorize.steps.payments.description"); },
      to: "/product-settings/payments",
      get actionLabel() { return sgT("fill"); },
      image: payments,
      get actions() {
        return [
          {
            label: sgT("fill"),
            to: "/product-settings/payments",
            variant: "primary",
          },
        ];
      },
    },
    [AUTHORIZE_START_GUIDE_STEP_IDS.PACKAGING]: {
      get name() { return sgT("authorize.steps.packaging.name"); },
      get description() { return sgT("authorize.steps.packaging.description"); },
      to: "/packaging/new",
      get actionLabel() { return sgT("fill"); },
      image: packaging,
      get actions() {
        return [{ label: sgT("fill"), to: "/packaging/new", variant: "primary" }];
      },
    },
    [AUTHORIZE_START_GUIDE_STEP_IDS.LABEL]: {
      get name() { return sgT("authorize.steps.label.name"); },
      get description() { return sgT("authorize.steps.label.description"); },
      to: "/packaging",
      get actionLabel() { return sgT("fill"); },
      image: digitalLabel,
      get actions() {
        return [{ label: sgT("fill"), to: "/packaging", variant: "primary" }];
      },
    },
    [AUTHORIZE_START_GUIDE_STEP_IDS.DECLARATION]: {
      get name() { return sgT("authorize.steps.declaration.name"); },
      get description() { return sgT("authorize.steps.declaration.description"); },
      to: "/packaging",
      get actionLabel() { return sgT("fill"); },
      image: labelFiles,
      get actions() {
        return [{ label: sgT("fill"), to: "/packaging", variant: "primary" }];
      },
    },
    [AUTHORIZE_START_GUIDE_STEP_IDS.REPRESENTATIVE]: {
      get name() { return sgT("authorize.steps.representative.name"); },
      get description() { return sgT("authorize.steps.representative.description"); },
      to: "/messages?tab=documentRequests",
      get actionLabel() { return sgT("fill"); },
      image: messages,
      get actions() {
        return [
          {
            label: sgT("fill"),
            to: "/messages?tab=documentRequests",
            variant: "primary",
          },
        ];
      },
    },
    [AUTHORIZE_START_GUIDE_STEP_IDS.HELP]: {
      get name() { return sgT("help.name"); },
      get description() { return sgT("authorize.steps.help.description"); },
      to: "/help",
      get actionLabel() { return sgT("openHelpCenter"); },
      image: helpCenter,
      get actions() {
        return [{ label: sgT("openHelpCenter"), to: "/help", variant: "primary" }];
      },
    },
  },
};
